import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  addWallet,
  cashout,
  convertFunds,
  deleteWallet,
  deposit,
  getUserByWalletId,
  getUserTransacactions,
  getUserWallet,
  transferFunds,
  getAllWallets,
  requestTransactionVerificationCode,
  verifyPaystackDeposit,
} from '../api';

export const useGetTransactions = (filters?: {
  pageSize?: number;
  startDate?: string;
  endDate?: string;
}) => {
  return useQuery({
    queryKey: ['transactions', filters],
    queryFn: () => getUserTransacactions(filters),
    //  refetchOnWindowFocus: 'always',
    staleTime: 30 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    keepPreviousData: true,
    select: (data) => {
      return data.data.resource.map((transaction: any) => ({
        ...transaction,
        amount: transaction.amount.toLocaleString(),
      }));
    },
  });
};

export const useGetWallet = () => {
  return useQuery({
    queryKey: ['wallet'],
    queryFn: getUserWallet,
    //refetchOnWindowFocus: 'always',
    // Balances change from things the user doesn't do themselves (a resale
    // being bought, bonuses paid) — don't show a 30-minute-old figure.
    staleTime: 30 * 1000,
    cacheTime: 30 * 60 * 1000,
    select: (data) => {
      return data.data.resource;
    },
  });
};

export const useDeposit = () => {
  return useMutation({
    mutationFn: deposit,
  });
};

export const useVerifyPaystackDeposit = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: verifyPaystackDeposit,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['wallet'] });
      queryClient.invalidateQueries({ queryKey: ['transactions'] });
    },
  });
};

export const useTransferFunds = () => {
  return useMutation({
    mutationFn: transferFunds,
  });
};

export const useConvertFunds = () => {
  return useMutation({
    mutationFn: convertFunds,
  });
};

export const useCashout = () => {
  return useMutation({
    mutationFn: cashout,
  });
};

export const useAddWallet = () => {
  return useMutation({
    mutationFn: addWallet,
  });
};

export const useGetUserByWalletId = () => {
  return useMutation({
    mutationFn: getUserByWalletId,
  });
};

export const useDeleteWallet = () => {
  return useMutation({
    mutationFn: deleteWallet,
  });
};

export const useGetAllWallets = () => {
  return useQuery({
    queryKey: ['wallets'],
    queryFn: getAllWallets,
    //refetchOnWindowFocus: 'always',
    staleTime: 30 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
    select: (data) => {
      return data.data.resource;
    },
  });
};

export const useRequestTransactionVerificationCode = () => {
  return useMutation({
    mutationFn: requestTransactionVerificationCode,
  });
};
